export default {
  PageFacturae: {
    // Headers and titles
    rectificative_invoice_title: 'CREDIT NOTE',
    rectifies_invoice: 'Corrects invoice {invoiceNumber} dated {invoiceDate}',
    substitution_invoice_title: 'SUBSTITUTE INVOICE',
    substitutes_simplified_invoice: 'Replaces simplified invoice number and series {invoiceNumber}.',
    simplified_invoice_issue_date: 'Simplified invoice issue date: {invoiceDate}.',
    rectificative_reason_default: 'Reason: Credit note due to differences.',
    draft_watermark: 'DRAFT',

    // QR and verification
    qr_label: 'Tax QR:',
    qr_verifiable: 'Invoice verifiable at the Spanish Tax Agency (AEAT)',

    // Invoice numbers and dates
    invoice_number_label: '{documentType} number: ',
    external_invoice_number: 'External invoice number: ',
    invoice_date_label: '{documentType} date: ',
    due_date: 'Due date: ',
    operation_date: 'Transaction date: ',
    start_date: 'Start date: ',
    end_date: 'End date: ',
    signing_date: 'Signing date: ',

    // Supplier section
    issuer: 'Supplier',
    self_billing_notice: 'Self-billing',
    business_name: 'Company name: ',
    fiscal_name: 'Legal name: ',
    fiscal_address: 'Registered address: ',
    nif_cif: 'Tax ID: ',
    bank_account: 'Bank account: ',
    trade_name: 'Trade name: ',
    email_label: 'Email: ',
    phone_label: 'Phone:',
    website_label: 'Website:',

    // Customer section
    receiver: 'Customer',
    dire_label: 'DIRe:',
    accounting_office: 'Accounting office:',
    management_body: 'Management body:',
    processing_unit: 'Processing unit:',
    proposing_body: 'Proposing body:',

    // Details section
    details: '',
    details_of_budget: 'Quote details',
    details_of_delivery_note: 'Delivery note details',
    details_of_proforma: 'Proforma details',
    details_of_ticket: 'Receipt details',
    details_of_invoice: 'Invoice details',

    // Table headers
    description: 'Description',
    total: 'Total',
    quantity: 'Qty',
    unit_price: 'Unit price',
    discount: 'Discount',
    discount_percentage: 'Disc. %',
    withholding: 'Withholding',
    total_without_tax: 'Total (excl. {taxType})',

    // Document type headers
    proforma_label: 'Proforma',
    budget_label: 'Quote',
    delivery_note_label: 'Delivery note',
    date_of_proforma: 'Proforma date: ',
    date_of_budget: 'Quote date: ',
    date_of_delivery_note: 'Delivery note date: ',
    file_reference: 'Reference',
    file_date: 'Reference date: ',
    client_reference: 'Customer reference',

    // Totals section
    total_without_discounts: 'Subtotal',
    line_discount: 'Line discount',
    global_discount: 'Discount',
    total_without_taxes: 'Total excl. tax',
    total_withholding: 'Total withholding',
    equivalence_surcharge_short: 'Eq. surch.',
    total_document: '{documentType} total',
    withholding_label: 'Withholding: ',
    reimbursable_label: 'Reimbursable expenses: ',
    total_to_pay: 'Amount due',

    // Document types for dynamic text
    invoice: 'Invoice',
    budget: 'Quote',
    delivery_note: 'Delivery note',
    proforma: 'Proforma',
    ticket: 'Receipt',

    // Footer
    page_number: 'Page {currentPage} of {totalPages}',
    document_info: '{documentType} no.: {invoiceNumber} ({invoiceDate})',

    // Tax exemption reasons (IVA)
    tax_reason_isp: 'Reverse charge pursuant to Art. 84.Uno of Spanish VAT Law 37/1992.',
    tax_reason_ns: 'Transaction not subject to VAT pursuant to Art. 7 of Spanish VAT Law 37/1992.',
    tax_reason_ex: 'VAT exempt transaction pursuant to Art. 20 of Spanish VAT Law 37/1992.',
    tax_reason_nsrl: 'Transaction not subject to VAT due to place of supply rules pursuant to Art. 69 of Spanish VAT Law 37/1992.',
    tax_reason_intra_bie: 'Intra-Community supply exempt pursuant to Art. 25 of Spanish VAT Law 37/1992.',
    tax_reason_intra_ser: 'Transaction not subject to VAT pursuant to Art. 69 of Spanish VAT Law 37/1992. Reverse charge according to Directive 2006/112/EC.',
    tax_reason_export: 'Export exempt transaction pursuant to Art. 21 of Spanish VAT Law 37/1992.',
    // Tax exemption reasons (IGIC)
    tax_reason_igic_art50: 'IGIC exempt transaction pursuant to Art. 50 of Law 4/2012.',
    tax_reason_igic_art11: 'IGIC exempt transaction pursuant to Art. 11 of Law 20/1991.',
    tax_reason_igic_art12: 'IGIC exempt transaction pursuant to Art. 12 of Law 20/1991.',
    tax_reason_igic_art13: 'IGIC exempt transaction pursuant to Art. 13 of Law 20/1991.',
    tax_reason_igic_art25: 'IGIC exempt transaction pursuant to Art. 25 of Law 19/1994.',
    tax_reason_igic_art47: 'IGIC exempt transaction pursuant to Art. 47 of Law 19/1994.',
    tax_reason_igic_art110: 'IGIC exempt transaction pursuant to Art. 110 of Law 4/2012.',
    tax_reason_igic_otros: 'IGIC exempt transaction.',

    // Payment methods
    payment_means_01: 'Cash payment',
    payment_means_02: 'Direct debit',
    payment_means_03: 'Receipt payment',
    payment_means_04: 'Bank transfer',
    payment_means_05: 'Accepted bill of exchange',
    payment_means_06: 'Documentary credit',
    payment_means_07: 'Award contract',
    payment_means_08: 'Bill of exchange',
    payment_means_09: 'Promissory note to order',
    payment_means_10: 'Promissory note not to order',
    payment_means_11: 'Cheque payment',
    payment_means_12: 'Replacement',
    payment_means_13: 'Special payment methods',
    payment_means_14: 'Compensation',
    payment_means_15: 'Postal money order',
    payment_means_16: 'Certified cheque',
    payment_means_17: 'Bank cheque',
    payment_means_18: 'Cash on delivery',
    payment_means_19: 'Card payment',
    payment_means_13_1: 'PayPal payment',
    payment_means_13_2: 'Confirming payment',
  }
}
